var _excluded = ["children", "classes", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { node, string, object } from 'prop-types';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
var Root = styled('div')(function (_ref) {
  var palette = _ref.theme.palette;
  return {
    alignItems: 'center',
    borderRight: "1px solid ".concat(palette.divider),
    display: 'flex',
    flex: '0 0 auto',
    justifyContent: 'space-between',
    paddingLeft: 0,
    position: 'relative',
    height: '100%',
    '&:last-child': {
      borderRight: 0
    }
  };
});

/**
 * `SovosToolbarGroup` wraps elements of specific type. Can have left
 * border if it's not first.
 *
 * **Note**: must be a child of `SovosToolbar`
 */
var SovosToolbarGroup = function SovosToolbarGroup(_ref2) {
  var children = _ref2.children,
    classes = _ref2.classes,
    className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(Root, _extends({
    className: clsx('sovosToolbarGroup', className, classes === null || classes === void 0 ? void 0 : classes.root)
  }, props), children);
};
SovosToolbarGroup.propTypes = {
  /**
   * The content of the toolbar group
   */
  children: node,
  /**
   * Override or extend the styles applied to the component
   */
  classes: object,
  /**
   * Extend the class name applied to the root element
   */
  className: string
};
export default SovosToolbarGroup;